<template>
    <div
        class="toggleButtons"
        :class="{
            loadingState: loading,
        }"
    >
        <div
            v-for="button in buttons"
            class="button toggleButtons__item"
            :class="{
                'is-primary': selectedValue === button.value,
            }"
            @click="toggleButtons(button)"
        >
            {{ button.label }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        buttons: { type: Array },
        loading: { type: Boolean, default: false },
        default: { type: Number, default: 0 },
        disabled: { type: Boolean, default: false },
    },

    emits: ['toggleButtons'],

    data: () => ({
        selected: null,
    }),

    computed: {
        selectedValue() {
            return this.selected && this.selected.value;
        },
    },

    methods: {
        init() {
            this.selected = this.buttons[this.default];

            this.$emit('toggleButtons', this.selected);
        },

        toggleButtons(item) {
            if (this.loading || this.disabled) return;

            this.selected = item;

            this.$emit('toggleButtons', item);
        },
    },

    mounted() {
        this.init();
    },
};
</script>
